import * as GenModels from '../models/GenericModels';
import * as ServiceMasterMdl from '../models/ServiceMasterModel';

export interface BillToModel {
    id: string;
    name: GenModels.Name;
    address: GenModels.Address;
    phone: GenModels.PhoneNumbers;
    paymentTerm: string;
    creditOnHold: boolean;
    emailAddress: string;
    webSiteAddress: string;
    serviceMasters: ServiceMasterMdl.ServiceMaster[];
    sawinClientName: string;
    companyCode: string;
    primaryAccount: boolean;
    creditCardEnabled: boolean;
    useWhiteBoard: boolean;
    showContractDescription: boolean;
    numOfDaysToRequestService: number;
    ccMode: string;
}

export const initialState: BillToModel = {

    id: '',
    name: { ...GenModels.initialStateName },
    address: { ...GenModels.initialStateAddress } ,
    phone: { ...GenModels.initialStatePhoneNumber },
    paymentTerm: '',
    creditOnHold: false,
    emailAddress: '',
    webSiteAddress: '',
    sawinClientName: '',
    companyCode: '',
    serviceMasters: [],
    primaryAccount: false,
    creditCardEnabled: false,
    useWhiteBoard: false,
    showContractDescription: false,
    numOfDaysToRequestService: 0,
    ccMode: ''
};

export interface BillToList { //extends GenModels.HttpResultBase {
    items: BillToModel[];
}

export const initialARInfoState: BillToList = {
    items: [] //, ...GenModels.initialHttpResultBase    
};